module.exports = __webpack_public_path__ + "static/img/partner5.33fe083.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partner5.png
// module id = xeUM
// module chunks = 0